import { useState, useEffect } from "react";

let idCounter = 0;

export function useToast() {
	const [toasts, setToasts] = useState([]);

	useEffect(() => {
		if (toasts.length === 0) return;
		const timers = toasts.map((toast) =>
			setTimeout(() => {
				setToasts((prev) => prev.filter((t) => t.id !== toast.id));
			}, toast.duration || 3000)
		);

		return () => timers.forEach(clearTimeout);
	}, [toasts]);

	const showToast = (message, type = "info", duration = 3000) => {
		setToasts((prev) => [
			...prev,
			{ id: ++idCounter, message, type, duration },
		]);
	};

	const ToastContainer = () => (
		<div style={styles.container}>
			{toasts.map((toast) => (
				<div
					key={toast.id}
					style={{ ...styles.base, ...styles[toast.type] }}>
					{toast.message}
				</div>
			))}
		</div>
	);

	return {
		showSuccess: (msg, duration) => showToast(msg, "success", duration),
		showError: (msg, duration) => showToast(msg, "error", duration),
		showWarning: (msg, duration) => showToast(msg, "warning", duration),
		showInfo: (msg, duration) => showToast(msg, "info", duration),
		ToastContainer,
	};
}

const styles = {
	container: {
		position: "fixed",
		top: "1rem",
		right: "1rem",
		zIndex: 9999,
		display: "flex",
		flexDirection: "column",
		gap: "0.5rem",
	},
	base: {
		padding: "12px 20px",
		borderRadius: "6px",
		color: "#fff",
		fontFamily: "sans-serif",
		boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
		minWidth: "200px",
		maxWidth: "300px",
		fontSize: "14px",
	},
	success: { backgroundColor: "#4CAF50" },
	error: { backgroundColor: "#F44336" },
	warning: { backgroundColor: "#FF9800" },
	info: { backgroundColor: "#2196F3" },
};
